export default __webpack_public_path__ + "static/media/7.17fadf51.jpg";